function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import map from 'lodash/map';
import { AppContext } from 'context';
import { getSlug } from 'helpers/urlTools';
import Star from 'svg/star-filled.svg';
import Avatar from 'components/Avatar';
import Link from 'components/Link';
import SidebarPersonsLoader from 'components/Loaders/SidebarPersonsLoader';
import App from 'modules/App';
import Account from 'modules/Account';
import filterBySearch from 'modules/Hcp/partials/PatientsList/helpers/filterBySearch';
import * as selectors from '../../selectors';
import styles from './PatientsList.pcss';
var _React_PureComponent;
class ActivePatients extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        // eslint-disable-next-line react/prop-types
        const { patients, search, maxPatientLength } = props;
        return filterBySearch(patients, 'id', search, state, maxPatientLength, '', [
            'isFavorite'
        ], [
            'desc'
        ]);
    }
    componentDidMount() {
        const { filteredCollectionIds } = this.state;
        this.props.setActivePatientsLength(filteredCollectionIds.length);
    }
    componentDidUpdate(prevProps, prevState) {
        const { filteredCollectionIds } = this.state;
        if (prevState.filteredCollectionIds.length !== filteredCollectionIds.length) {
            this.props.setActivePatientsLength(filteredCollectionIds.length);
        }
    }
    renderAvatar(patient) {
        const { avatar, firstName, lastName } = patient;
        return /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: avatar,
            name: [
                firstName,
                lastName
            ],
            className: styles.item__avatar,
            imgClassName: styles.item__avatar__img,
            initialsClassName: styles.item__avatar__initials
        });
    }
    renderPatient(patient) {
        if (!patient || this.props.omitPatient && patient.id === this.props.omitPatient.id) {
            return null;
        }
        const { patientId } = this.props.route.params;
        const { organizationUID, name } = get(this.props.activeClinicMembership, 'clinic', {});
        const clinicSlug = getSlug(name);
        const patientSlug = getSlug(`${patient.firstName} ${patient.lastName}`);
        return /*#__PURE__*/ _jsx("li", {
            className: cn(styles.item, {
                [styles['item--active']]: this.props.route.name === 'hcp-results' && patientId === patient.id,
                [styles['item--halfSpace']]: this.props.styleModifier === 'halfSpace',
                [styles['item--halfSpaceActive']]: this.props.styleModifier === 'halfSpace' && this.props.route.name === 'hcp-results' && patientId === patient.id,
                [styles[`item__${this.props.id}`]]: styles[`item__${this.props.id}`],
                [styles[`item__${this.props.id}--active`]]: styles[`item__${this.props.id}`] && patientId === patient.id
            }),
            children: /*#__PURE__*/ _jsx(Link, {
                to: this.context.getUrl('hcp-results', {
                    clinicSlug,
                    organizationUID,
                    patientSlug,
                    patientId: patient.id
                }),
                onClick: (evt)=>{
                    if (this.props.onClick) {
                        this.props.onClick(evt, patient);
                    }
                },
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "row flex-nowrap align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-auto pr-2",
                            children: this.renderAvatar(patient)
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col px-3",
                            children: /*#__PURE__*/ _jsxs("p", {
                                "data-hj-suppress": true,
                                className: cn(styles.item__name, {
                                    [styles['item__name--withMenu']]: patient.isFavorite,
                                    [styles[`item__name--${this.props.id}`]]: styles[`item__name--${this.props.id}`]
                                }),
                                children: [
                                    patient.firstName,
                                    " ",
                                    patient.lastName
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-auto pl-2",
                            children: /*#__PURE__*/ _jsx(Star, {
                                className: cn(styles.star, {
                                    [styles.star_active]: patient.isFavorite
                                })
                            })
                        })
                    ]
                })
            })
        }, patient.id);
    }
    render() {
        if (this.props.isInProgress) {
            return /*#__PURE__*/ _jsx(SidebarPersonsLoader, {
                itemsNumber: 5
            });
        }
        return /*#__PURE__*/ _jsx("ul", {
            id: this.props.id,
            className: styles.items,
            children: map(this.state.filteredCollection, (patient)=>this.renderPatient(patient))
        });
    }
    constructor(props){
        super(props);
        this.state = {
            filteredCollection: [],
            filteredCollectionIds: [],
            search: ''
        };
    }
}
_define_property(ActivePatients, "contextType", AppContext);
_define_property(ActivePatients, "propTypes", {
    // Explicit props
    id: PropTypes.string.isRequired,
    omitPatient: PropTypes.object,
    activeClinicMembership: Account.shapes.clinicMembership,
    styleModifier: PropTypes.oneOf([
        'halfSpace'
    ]),
    // Explicit actions
    onClick: PropTypes.func,
    setActivePatientsLength: PropTypes.func,
    // Implicit props
    isInProgress: PropTypes.bool,
    route: App.shapes.route
});
_define_property(ActivePatients, "defaultProps", {
    setActivePatientsLength: ()=>{}
});
const mapStateToProps = (state, props)=>({
        patients: selectors.patients(state),
        search: selectors.searchSelector(props.id)(state),
        isInProgress: selectors.isFetchPatientsInProgress(state),
        route: App.selectors.route(state)
    });
const ConnectedActivePatients = connect(mapStateToProps)(ActivePatients);
export default withStyles(styles)(ConnectedActivePatients);
